'use strict'

import React, { useMemo } from 'react';
import { createPath } from 'history';

import { getHistory } from '@/history';

export default ({ to, children, className, isDisabled }) => {

	if (isDisabled) {
		return (
			<div className={ className }>
				{ children }
			</div>
		);
	}

	const history = useMemo(() => getHistory());

	const { state } = to;

	const onClick = e => {

		e.preventDefault();

		if (state) {
			history.push(to, state);
		} else {
			history.push(to);
		}
	};

	let href;

	if (typeof to === 'string' || to instanceof String) {
		href = to;
	} else {
		href = createPath(to);
	}

	return (
		<a href={ href } onClick={ onClick } className={ className }>
			{ children }
		</a>
	);
};
